import { render, staticRenderFns } from "./EditSimpleUser.vue?vue&type=template&id=609a8b65"
import script from "./EditSimpleUser.vue?vue&type=script&lang=ts"
export * from "./EditSimpleUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports